import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ProductCategory1 from '../helpers/ProductCategory1';  // Fetch categories dynamically
import VerticalCard from '../components/VerticalCard';
import SummaryApi from '../common';

const CategoryProduct = () => {
    const [data, setData] = useState([]);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const urlSearch = new URLSearchParams(location.search);
    const urlCategoryListinArray = urlSearch.getAll("category");

    const urlCategoryListObject = {};
    urlCategoryListinArray.forEach(el => {
        urlCategoryListObject[el] = true;
    });

    const [selectCategory, setSelectCategory] = useState(urlCategoryListObject);
    const [filterCategoryList, setFilterCategoryList] = useState([]);
    const [sortBy, setSortBy] = useState("");

    const categories = ProductCategory1(); // Fetch categories dynamically

    const fetchData = async () => {
        try {
            console.log("Fetching products with categories:", filterCategoryList);
            setLoading(true);

            const response = await fetch(SummaryApi.filterProduct.url, {
                method: SummaryApi.filterProduct.method,
                headers: {
                    "content-type": "application/json",
                },
                body: JSON.stringify({ category: filterCategoryList }),
            });

            const dataResponse = await response.json();
            console.log("Fetched products:", dataResponse);
            
            if (dataResponse && Array.isArray(dataResponse.data)) {
                setData(dataResponse.data);
            } else {
                console.error("Unexpected API response structure:", dataResponse);
                setData([]); // Ensure data is an array
            }
        } catch (error) {
            console.error("Error fetching products:", error);
            setData([]); // Ensure data is always an array
        } finally {
            setLoading(false);
        }
    };

    const handleSelectCategory = (e) => {
        const { value, checked } = e.target;

        setSelectCategory((prev) => ({
            ...prev,
            [value]: checked,
        }));
    };

    useEffect(() => {
        fetchData();
    }, [filterCategoryList]);

    useEffect(() => {
        const arrayOfCategory = Object.keys(selectCategory).filter((categoryKey) => selectCategory[categoryKey]);

        setFilterCategoryList(arrayOfCategory);

        // Format URL when checkbox changes
        const urlFormat = arrayOfCategory.map((el, index) =>
            index === arrayOfCategory.length - 1 ? `category=${el}` : `category=${el}&&`
        );

        navigate("/product-category?" + urlFormat.join(""));
    }, [selectCategory]);








    useEffect(() => {
    const categoryNames = filterCategoryList.join(", ") || "All Products";
    const title = `${categoryNames} - Shop Quality Products | Purchase Palace`;
    const description = `Explore top deals on ${categoryNames || "products"} at Purchase Palace. Affordable, high-quality, and fast delivery.`;

    document.title = title;

    let metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
        metaDesc.setAttribute("content", description);
    } else {
        metaDesc = document.createElement("meta");
        metaDesc.name = "description";
        metaDesc.content = description;
        document.head.appendChild(metaDesc);
    }
}, [filterCategoryList]);





    

    const handleOnChangeSortBy = (e) => {
        const { value } = e.target;
        setSortBy(value);

        setData((prev) => {
            const sortedData = [...prev];
            if (value === 'asc') {
                sortedData.sort((a, b) => a.sellingPrice - b.sellingPrice);
            } else if (value === 'dsc') {
                sortedData.sort((a, b) => b.sellingPrice - a.sellingPrice);
            }
            return sortedData;
        });
    };

    return (
        <div className='container mx-auto p-4'>
            {/*** Desktop Version ***/}
            <div className='hidden lg:grid grid-cols-[200px,1fr]'>
                {/*** Left Sidebar ***/}
                <div className='bg-white p-2 min-h-[calc(100vh-120px)] overflow-y-scroll'>
                    {/*** Sort By Section ***/}
                    <div>
                        <h3 className='text-base uppercase font-medium text-slate-500 border-b pb-1 border-slate-300'>Sort by</h3>
                        <form className='text-sm flex flex-col gap-2 py-2'>
                            <div className='flex items-center gap-3'>
                                <input type='radio' name='sortBy' checked={sortBy === 'asc'} onChange={handleOnChangeSortBy} value={"asc"} />
                                <label>Price - Low to High</label>
                            </div>
                            <div className='flex items-center gap-3'>
                                <input type='radio' name='sortBy' checked={sortBy === 'dsc'} onChange={handleOnChangeSortBy} value={"dsc"} />
                                <label>Price - High to Low</label>
                            </div>
                        </form>
                    </div>

                    {/*** Category Filter Section ***/}
                    <div>
                        <h3 className='text-base uppercase font-medium text-slate-500 border-b pb-1 border-slate-300'>Category</h3>
                        <form className='text-sm flex flex-col gap-2 py-2'>
                            {Array.isArray(categories) && categories.length > 0 ? (
                                categories.map((category) => (
                                    <div key={category._id} className='flex items-center gap-3'>
                                        <input
                                            type='checkbox'
                                            name={"category"}
                                            checked={selectCategory[category.categoryName] || false}
                                            value={category.categoryName}
                                            onChange={handleSelectCategory}
                                        />
                                        <label htmlFor={category._id}>{category.categoryName}</label>
                                    </div>
                                ))
                            ) : (
                                <p>No categories available.</p>
                            )}
                        </form>
                    </div>
                </div>

                {/*** Right Side (Products) ***/}
                <div className='px-4'>
                    <p className='font-medium text-slate-800 text-lg my-2'>Search Results: {Array.isArray(data) ? data.length : 0}</p>
                    <div className='min-h-[calc(100vh-120px)] overflow-y-scroll max-h-[calc(100vh-120px)]'>
                        {Array.isArray(data) && data.length > 0 && !loading ? (
                            <VerticalCard data={data} loading={loading} />
                        ) : loading ? (
                            <p>Loading products...</p>
                        ) : (
                            <p>No products found.</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CategoryProduct;
